//const API_HOST = 'http://bodybackend.pm/';
// const API_HOST = 'http://tikasahebbackend.pm';
// const API_HOST = 'http://127.0.0.1:8000';
const API_HOST = 'https://glamgenesis.com/backend';
// const API_HOST = 'https://tikasahebbackend.pmcommu.in';


export default API_HOST;